var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagYougoslavia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagYougoslavia_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagYougoslavia_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagYougoslavia_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagYougoslavia_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagYougoslavia_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003893",
    fillRule: "nonzero",
    d: "M-16 4h80v40h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M-16 17.333h80V44h-80z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#DE0000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16 30.666h80V44h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FCD115",
    strokeWidth: 0.711,
    d: "M24 11.817l2.735 8.418h8.851l-7.16 5.203 2.735 8.418L24 28.654l-7.161 5.202 2.735-8.418-7.161-5.203h8.851z"
  }))))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iZXNjOXd5cnk2YSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJhZmt5MTd3YXliIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2VzYzl3eXJ5NmEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiNlc2M5d3lyeTZhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjYWZreTE3d2F5YikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzAwMzg5MyIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMCAwTDgwIDAgODAgNDAgMCA0MHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNiA0KSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGNEY0RjQiIGQ9Ik0wIDEzLjMzM0w4MCAxMy4zMzMgODAgNDAgMCA0MHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNiA0KSIvPgogICAgICAgICAgICAgICAgICAgIDxnIGZpbGw9IiNERTAwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wIDE4Ljg0OUw4MCAxOC44NDkgODAgMzIuMTgzIDAgMzIuMTgzeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2IDQpIHRyYW5zbGF0ZSgwIDcuODE3KSIvPgogICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBzdHJva2U9IiNGQ0QxMTUiIHN0cm9rZS13aWR0aD0iLjcxMSIgZD0iTTQwIDBMNDIuNzM1IDguNDE4IDUxLjU4NiA4LjQxOCA0NC40MjYgMTMuNjIxIDQ3LjE2MSAyMi4wMzkgNDAgMTYuODM3IDMyLjgzOSAyMi4wMzkgMzUuNTc0IDEzLjYyMSAyOC40MTMgOC40MTggMzcuMjY0IDguNDE4eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2IDQpIHRyYW5zbGF0ZSgwIDcuODE3KSIvPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgFlagYougoslavia as ReactComponent };